import axios from 'axios';

// Backend ka base URL
const API_URL = '/api/feedback';

// 1. Feedback Submit karne ke liye
export const submitFeedback = async (feedbackData) => {
    const token = localStorage.getItem('token');
    
    // Authorization header (Agar backend ko token chahiye)
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    // Yahan URL check karo: API_URL + '/submit' = '.../api/feedback/submit'
    const response = await axios.post(`${API_URL}/submit`, feedbackData, config);
    return response.data;
};

// 2. Admin Panel ke liye saara feedback fetch karne ke liye
export const getAllFeedback = async () => {
    const token = localStorage.getItem('token');
    
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    const response = await axios.get(`${API_URL}/all`, config);
    return response.data.data; // Controller se jo 'data' array aa raha hai
};

// 3. Admin Panel se status update (Approve ya Reject) karne ke liye
export const updateFeedbackStatus = async (feedbackId, status) => {
    const token = localStorage.getItem('token');
    
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    const response = await axios.put(`${API_URL}/update-status`, { feedbackId, status }, config);
    return response.data;
};

// 4. Public website ke liye sirf approved feedback lane ke liye (Bina token ke)
export const getApprovedFeedback = async () => {
    const response = await axios.get(`${API_URL}/approved`);
    return response.data.data;
};